import * as React from "react";
import EdButton from "../../../generic/edButton";
import "../../../../assets/scss/components/toc/orderBook/generic/obToastMessPopup.scss";
export interface IObToastMessPopupProps {
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	onToastBtnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
	title: string;
	subtitle: string;
	buttonValue: string;
	btnTyp: "link" | "secondary" | "primary" | "blue-link";
}

const ObToastMessPopup: React.FC<IObToastMessPopupProps> = (props) => {
	const [disableBtn, setDisableBtn] = React.useState(false);

	function onToastBtnClick(e: React.MouseEvent<HTMLButtonElement>) {
		setDisableBtn(true);
		props.onToastBtnClick(e);
	}

	return (
		<div className="toast_mes_popup_wrap">
			<div className="toast_popup_container">
				<div className="close">
					<button className="cls" onClick={props.onBackClick}>
						<i className="edel-icon-close"></i>Close
					</button>
				</div>
				{/* According to popup need to add class conversion_error conversion_suss cancel */}
				<div className="toast_mes_popup_con cancel">
					<div className="toast_icon">
						<i className="edel-icon-tick"></i>
					</div>
					<h2 className="toast_tit">{props.title}</h2>
					<h3 className="toast_sub_tit">{props.subtitle}</h3>
					<div className="toast_btn">
						<EdButton value={props.buttonValue} btnTyp={props.btnTyp} onClick={onToastBtnClick} slim disabled={disableBtn} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ObToastMessPopup;
